// extracted by extract-css-chunks-webpack-plugin
module.exports = {"oneColumn":"Form-830a70fd1d72205f","twoColumns":"Form-afe5f10922282d8b","column":"Form-5b03329c8d4fd276"};